






















import {Component, Vue, Prop, Mixins} from 'vue-property-decorator';
import {Mixin} from "@/mixins";

@Component({
    name: "Section",
})
export default class Section extends Mixins(Mixin) {
    @Prop({default: true})
    nextButton!: boolean;

    @Prop({default: null})
    buttonError!: string|null;

    next() {
        this.$emit('next');
    }
}
